// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__uXPTj","active":"button_active__E1Fhs"};